import { createDecoratedRoute } from '@cp-shared-19/frontend-ui';
import { Authentication } from './Authentication';

export const AuthenticatedRoute = createDecoratedRoute('AuthenticatedRoute', Authentication);
